import { sessionService } from '@life-time-inc/enterprise-framework-core';

export const parseCookie = <T>(name: string, defaultValue?: T, zoneId?: string): T | null => {
	const cookie: string = sessionService.getCookie(name, zoneId);
	if (cookie) {
		return JSON.parse(cookie) as T;
	}
	return defaultValue ?? null;
};
